import { useGetUserQuery } from '@/api/piloteer';
import { useAppSelector } from '@/store/hooks';
import { UserRole } from '@/types/user';
import { APP_ROUTES } from '@/ui/application-routes';
import { FunctionComponent, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { coachCanAccessPath } from './coach-access';

type EnforceAuthProps = {
  children: React.ReactNode;
};

export const EnforceAuth: FunctionComponent<EnforceAuthProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, isLoading, error } = useAppSelector((state) => state.auth);

  const user = useGetUserQuery(undefined, { skip: !session });

  useEffect(() => {
    if (isLoading) return;
    if (error) {
      navigate(APP_ROUTES.AUTH.MAIN, { replace: true });
    }
    if (!session) {
      navigate(APP_ROUTES.AUTH.MAIN, { replace: true });
    }
  }, [session, isLoading, error, navigate]);

  if (isLoading || error || !session) {
    return null;
  }

  if (user.isLoading || user.error || !user.data) return null;
  if (
    user.data.role === UserRole.COACH &&
    !coachCanAccessPath(location.pathname)
  )
    return <Navigate to={APP_ROUTES.COACH.MAIN} replace />;

  return <>{children}</>;
};
